// extracted by mini-css-extract-plugin
module.exports = {"noFreezeSpinner":"loader_noFreezeSpinner__mClFs","rotate":"loader_rotate__JDw7O","loadicons":"loader_loadicons__lZwCN"};